import React from 'react';
import { Text, Textarea } from '@chakra-ui/react';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

interface ConfirmCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
  onConfirm: (explanation: string) => void;
  clientName: string;
}

const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({ isOpen, onClose, onBack, onConfirm, clientName }) => {
  const [explanation, setExplanation] = React.useState('');

  const handleSubmit = () => {
    onConfirm(explanation);
    onClose();
  };

  const handleBackAndClose = () => {
    onBack();
    onClose();
  };

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title="Want to cancel?"
      cancelLabel="Back"
      onCancel={handleBackAndClose}
      primary={{ label: 'Yes, cancel', onClick: handleSubmit, tone: 'danger', isDisabled: explanation.length === 0 }}
    >
      <Text color={ff.text2} mb={3}>Let us know why.</Text>
      <Textarea
        placeholder={`We'll let ${clientName} know you're no longer interested.`}
        value={explanation}
        onChange={(e) => setExplanation(e.target.value)}
        borderRadius="16px"
        borderColor={ff.border}
        minH="120px"
        _focus={{ borderColor: ff.ink, boxShadow: 'none' }}
      />
    </ModalShell>
  );
};

export default ConfirmCancelModal;
